import Vue from 'vue'
import operate from "./deviceOperate.vue";

const PopupBox = Vue.extend(operate);

operate.install = function (data) {
  let instance = new PopupBox({
    data
  }).$mount();

  document.body.appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.show = true
    // show 和弹窗组件里的show对应，用于控制显隐
  })
};

export default operate



// WEBPACK FOOTER //
// ./src/components/popup/deviceOperate.js